import { apiInstance } from "./ApiInstance";

class AuthService {    
    static login(email, password){
        // Cambiado a email según requerimiento de backend
        return apiInstance.post('/login', { email, password });
    }
    static refresh() {
        return apiInstance.post('/refresh'); // Ajusta la ruta según tu backend
    }

    static getPermisos(){
        return apiInstance.get('/permisos');
    }
    
    static logout() {
        // Laravel Sanctum tiene un endpoint por defecto o uno que tú crees
        // Generalmente es /logout o /api/logout
        return apiInstance.post('/logout');
    }
}

export { AuthService };